module.exports = __webpack_public_path__ + "img/interrogate.b67eb235.png";